import React from 'react';
import {Link} from 'react-router-dom';
import {
    getFeature,
    FEATURE__BROWSER_ROUTER
} from '../utils/features';

let _fullWidgetUrl;
export const _setFullWidgetUrl = url => (_fullWidgetUrl = url);

const FullWidgetLink = ({
    to,
    ...props
}) => {
    const delimiter = getFeature(FEATURE__BROWSER_ROUTER) ? '' : '#';

    return _fullWidgetUrl
        ? <a {...props} href={`${_fullWidgetUrl}${delimiter}${to}`} />
        : <Link {...props} to={to}  />
};

export default FullWidgetLink;
